// Upload de XML NF-e · drop zone + chama edge function binario-wms-ingest
import { repo } from '../client.js';
import { escapeHTML, BRL, NUM } from '../shared.js';

export async function viewUpload($c) {
  $c.innerHTML = `
    <header class="page-head">
      <div>
        <div class="kicker">INGESTÃO MANUAL</div>
        <h1>Upload de <strong>XML NF-e</strong></h1>
        <p class="lead">Arraste um ou mais XMLs nfeProc (uma NF por arquivo). O sistema parseia, normaliza e grava em <span class="mono-inline">binario_wms.nfe_xml + movimento</span>. Idempotente — reenvie sem medo.</p>
      </div>
    </header>

    <div class="card">
      <div id="drop-zone" class="drop-zone">
        <div class="drop-icon">▽</div>
        <h3>Arraste XMLs aqui</h3>
        <p class="text-mute">ou clique para selecionar arquivos</p>
        <input type="file" id="file-input" multiple accept=".xml,application/xml,text/xml" style="display:none">
      </div>
    </div>

    <div class="card" id="ingest-log-card" style="display:none;">
      <div class="card-head"><h2>Resultado da ingestão <span id="ingest-count" class="count"></span></h2></div>
      <div id="ingest-log"></div>
    </div>

    <div class="grid-2">
      <div class="card">
        <div class="card-head"><h2>O que acontece quando você envia</h2></div>
        <ol style="padding-left: 20px; line-height: 1.9; font-size: 14px;">
          <li>Parser extrai cabeçalho (chave, emitente, destinatário, CFOP, datas)</li>
          <li>Direção é inferida (CFOP 1-3 → inbound · 5-7 → outbound)</li>
          <li>Natureza é mapeada (importação, venda, RMA, etc.)</li>
          <li>NF-e + itens são gravados em <span class="mono-inline">nfe_xml</span> e <span class="mono-inline">movimento</span></li>
          <li>SKUs novos são auto-cadastrados em <span class="mono-inline">sku_master</span></li>
          <li>Ingest_run registra a auditoria completa</li>
        </ol>
      </div>
      <div class="card">
        <div class="card-head"><h2>Reenvio é seguro</h2></div>
        <p class="body">A pipeline é <strong style="font-weight: 500;">idempotente via ON CONFLICT (chave_nfe, n_item)</strong>. Mandar 100 vezes o mesmo XML resulta em uma única linha por NF e uma por item. Atualiza <span class="mono-inline">updated_at</span>; não duplica.</p>
        <div class="rule"></div>
        <p class="text-sm text-mute">Para integração automatizada: <span class="mono-inline">POST /functions/v1/binario-wms-ingest</span> com header <span class="mono-inline">X-Ingest-Source</span>.</p>
      </div>
    </div>
  `;

  const dz = document.getElementById('drop-zone');
  const fi = document.getElementById('file-input');
  const log = document.getElementById('ingest-log');
  const logCard = document.getElementById('ingest-log-card');
  const countEl = document.getElementById('ingest-count');

  let totalOk = 0, totalErr = 0;

  async function handleFiles(files) {
    if (!files || !files.length) return;
    logCard.style.display = 'block';
    for (const f of files) {
      const row = document.createElement('div');
      row.className = 'ingest-row processing';
      row.innerHTML = `<span class="spinner"></span><span class="ingest-name">${escapeHTML(f.name)}</span><span class="ingest-status">processando…</span>`;
      log.prepend(row);
      try {
        const text = await f.text();
        const res = await repo.ingestXml(text);
        totalOk++;
        row.className = 'ingest-row ok';
        row.innerHTML = `
          <span class="check-icon">✓</span>
          <span class="ingest-name">${escapeHTML(f.name)}</span>
          <span class="ingest-meta">
            <span class="pill ${res.fluxo === 'inbound' ? 'pill-green' : 'pill-amber'}">${res.fluxo.toUpperCase()}</span>
            <span class="text-mono text-sm">NF ${res.nf_numero || '—'} · ${res.n_itens} itens</span>
          </span>`;
      } catch (e) {
        totalErr++;
        row.className = 'ingest-row err';
        row.innerHTML = `<span class="x-icon">✕</span><span class="ingest-name">${escapeHTML(f.name)}</span><span class="ingest-status err">${escapeHTML(e.message || String(e))}</span>`;
      }
      countEl.textContent = `${totalOk} OK · ${totalErr} erro${totalErr === 1 ? '' : 's'}`;
    }
  }

  dz.addEventListener('click', () => fi.click());
  fi.addEventListener('change', (e) => handleFiles(e.target.files));
  ['dragover', 'dragenter'].forEach(ev => dz.addEventListener(ev, e => {
    e.preventDefault(); dz.classList.add('drag-over');
  }));
  ['dragleave', 'dragend', 'drop'].forEach(ev => dz.addEventListener(ev, e => {
    e.preventDefault(); dz.classList.remove('drag-over');
  }));
  dz.addEventListener('drop', e => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    handleFiles(files);
  });
}
